// import { Injectable } from '@angular/core';
// import { Subject, BehaviorSubject, Observable } from 'rxjs';
// import { HttpClient } from '@angular/common/http';
// import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
// import { environment } from 'src/environments/environment';
// import { Session } from '../../classes/session/session';

// @Injectable({
//   providedIn: 'root'
// })
// export class SessionService {
//   user: Session = new Session();
//   notification_regid;

//   session: BehaviorSubject<Session> = new BehaviorSubject(null);
//   constructor(
//     private router: Router,
//     private http: HttpClient,

//   ) {
//     this.updateSession();
//   }

//   canActivate(
//     route: ActivatedRouteSnapshot,
//     state: RouterStateSnapshot
//   ) {

//     // if (route.routeConfig.path == 'login') {
//     //
//     //   if (this.checkSession()) {
//     //     setTimeout(() => {
//     //       this.router.navigate(['/dashboard']);
//     //       return false;
//     //     })
//     //   }
//     //   else {
//     //     return true;
//     //   }
//     // }
//     // else {
//     if (this.checkSession()) {
//       return true;
//     }
//     else {
//       this.router.navigate(['/jobs']);
//       return false;
//     }
//     // }

//   }
//   setSession(obj) {
//     let session = new Session();
//     session.setData(obj);
//     if (session) {
//       let item = btoa(JSON.stringify(session));
//       sessionStorage.setItem('u', item);
//       this.updateSession();
//     }
//   }

//   updateSession() {
//     let session = sessionStorage.getItem('u');
//     if (session) {
//       let user = JSON.parse(atob(session));
//       if (user && user.access_token) {
//         this.user.setData(user);
//         this.session.next(user);
//         return this.user;
//       }
//     }
//     return null;
//   }

//   getSession(): Observable<Session> {
//     return this.session.asObservable();
//   }

//   logout() {
//     sessionStorage.removeItem('u');
//     this.user = new Session();
//     this.session.next(null)
//     // this.redirectTo('/jobs');

//     // private tab_svc: EntityTabsService
//     // this.tab_svc.clearTabs();
//   }

//   updateNotificationRegId(reg_id) {
//     this.notification_regid = reg_id;
//     if (this.user.access_token) {
//       this.saveNotificationRegId();
//     }
//   }

//   saveNotificationRegId() {
//     this.http.post(environment.SERVER_URL + '/api/Requisition/regId', { notification_reg_id: this.notification_regid, access_token: this.user.access_token }).subscribe(res => {

//     })
//   }

//   getUserId() {
//     if (this.user) {
//       return this.user.UserId;
//     }
//     else {
//       return null;
//     }
//   }

//   checkSession() {
//     // this.updateSession();
//     if (this.user) {
//       return this.user.access_token;
//     }
//     else {
//       return null;
//     }
//   }

// }
import { Injectable, Injector } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Session } from '../../classes/session/session';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { environment } from 'src/environments/environment';
import { removeLocalStorageItem, removeSessionStorageItem } from 'src/app/controls/functions/functions';
import { jsonParse } from 'src/app/app.component';
@Injectable({
  providedIn: 'root'
})
export class SessionService {
  user: Session = new Session();
  notification_regid;

  session: BehaviorSubject<any> = new BehaviorSubject(null);
  my_journey_details: BehaviorSubject<any> = new BehaviorSubject(null);
  access_rights: Object;
  path;
  constructor(
    private router: Router,
    private http: HttpClient,
    private notification_src: NotificationService,
    private injector: Injector
  ) {
    this.updateSession();
  }
  setSession(obj) {
    let session = new Session();
    session.setData(obj);
    if (session) {
      let item = btoa(JSON.stringify(session));
      sessionStorage.setItem('u', item);
      this.updateSession();
    }
  }

  setUserDetails(obj) {
    this.user.setUserDetails(obj);
    let user = this.user.getUserDetails();
    if (user) {
      let item = btoa(JSON.stringify(user));
      sessionStorage.setItem('u', item);
      this.session.next(user);
    }
  }


  setMyJourneyDetails(obj) {
    if (obj) {
      let item = btoa(JSON.stringify(obj));
      sessionStorage.setItem('mj', item);
      this.my_journey_details.next(obj);
    }
  }

  getMyJourneyDetails() {
    let details = sessionStorage.getItem('mj');
    details = jsonParse(atob(details))
    return details;
  }

  updateSession() {
    let session = sessionStorage.getItem('u');
    if (session) {
      let user = JSON.parse(atob(session));
      if (user && user.token) {
        this.user.setData(user);
        this.session.next(user);
        return this.user;
      }
    }
    return null;
  }
  getSessionData() {
    let session = sessionStorage.getItem('u');
    if (session) {
      let user = JSON.parse(atob(session));
      if (user && user.token) {
        return user;
      }
      else return null
    }
    else {
      return null;
    }  
  }

  getSession(): Observable<Session> {
    return this.session.asObservable();
  }

  logout(flag?) {
    try {
      sessionStorage.removeItem('resId');
    }
    catch (err) {
      console.log(err)
    }
    removeSessionStorageItem('resId');
    if (flag) {
      sessionStorage.removeItem('u');

      this.session.next(null);
      this.user = new Session();
      sessionStorage.removeItem('resId');
      this.router.navigate(['/login']);

    }
    else {
      let user
      try {
        user = atob(sessionStorage.getItem('u'))
        user = JSON.parse(user)
      }
      catch (err) {

        user = null;
      }

      if (user) {
        this.logoutAPI().subscribe(res => {
          if (res && res['status']) {
            // this.notification_src.success(res['message'], 'Close', 3000)
            sessionStorage.removeItem('u');
            this.session.next(null);
            // sessionStorage.setItem('access_rights', undefined);
            this.user = new Session();
            this.router.navigate(['/jobs']);
          }
          else {
            this.notification_src.error('Failed to logout try again', 'Close', 3000)
          }
        },
          err => {

            sessionStorage.removeItem('u');
            this.session.next(null);
            this.user = new Session();
            this.router.navigate(['/jobs']);

          })
      }

    }

    // private tab_svc: EntityTabsService
    // this.tab_svc.clearTabs();
  }

  checkUsertype() {
    let session = sessionStorage.getItem('u');
    if (session) {
      let user = JSON.parse(atob(session));
      if (user) {
        return user.isEmployer;
      }
      return null;
    }
    else {
      return null;
    }


  }

  checkSession() {

    if (this.user) {
      // this.updateSession();
      return this.user.token;
    }
    else {
      return null;
    }
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {

    if (route.routeConfig.path == 'login') {

      if (this.checkSession()) {
        this.path = route.url[0].path;
        setTimeout(() => {
          this.router.navigate(['/dashboard']);
          return false;
        })
      }
      else {
        return true;
      }
    }
    else {
      if (this.checkSession()) {
        this.path = route.url[0].path;
        // this.checkingAccessRights();
        return true;
      }
      else {
        this.router.navigate(['/login'], { queryParams: { from: state.url || 'dashboard' } });
        return false;
      }
    }

  }

  logoutAPI() {
    return this.http.get(environment.SERVER_URL + "icr/logout");
  }

}
